import type { MarqueeProps } from './Marquee.types';
import './Marquee.scss';

export default function Marquee({
  children, duration = 60, pauseOnHover = true, className,
}: MarqueeProps) {
  const style = { ['--marquee-duration' as string]: `${duration}s` } as React.CSSProperties;
  return (
    <div
      className={[
        'marquee',
        pauseOnHover ? 'marquee--pause-hover' : '',
        className || '',
      ].filter(Boolean).join(' ')}
      style={style}
      aria-label="Логотипы партнёров"
    >
      <div className="marquee__track">
        <div className="marquee__group">{children}</div>
        <div className="marquee__group" aria-hidden="true">{children}</div>
      </div>
      <div className="marquee__grid">{children}</div>
    </div>
  );
}
